import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

const reports = accountId => ({
  parentNav: 'reports',
  routes: [
    'account_overview_reports',
    'conversation_reports',
    'csat_reports',
    'bot_reports',
    'agent_reports',
    'label_reports',
    'inbox_reports',
    'team_reports',
    'sla_reports',
    'ads_reports',
    'ads_analytics_reports',
    'custom_analytics_reports',
    'co_living_reports',
  ],
  menuItems: [
    {
      icon: 'arrow-trending-lines',
      label: 'REPORTS_OVERVIEW',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/overview`),
      toStateName: 'account_overview_reports',
    },
    {
      icon: 'chat',
      label: 'REPORTS_CONVERSATION',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/conversation`),
      toStateName: 'conversation_reports',
    },
    {
      icon: 'emoji',
      label: 'CSAT',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/csat`),
      toStateName: 'csat_reports',
    },
    {
      icon: 'bot',
      label: 'REPORTS_BOT',
      hasSubMenu: false,
      featureFlag: FEATURE_FLAGS.RESPONSE_BOT,
      toState: frontendURL(`accounts/${accountId}/reports/bot`),
      toStateName: 'bot_reports',
    },
    {
      icon: 'people',
      label: 'REPORTS_AGENT',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/agent`),
      toStateName: 'agent_reports',
    },
    {
      icon: 'tag',
      label: 'REPORTS_LABEL',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/label`),
      toStateName: 'label_reports',
    },
    {
      icon: 'mail-inbox-all',
      label: 'REPORTS_INBOX',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/inboxes`),
      toStateName: 'inbox_reports',
    },
    {
      icon: 'people-team',
      label: 'REPORTS_TEAM',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/teams`),
      toStateName: 'team_reports',
    },
    {
      icon: 'document-list-clock',
      label: 'REPORTS_SLA',
      hasSubMenu: false,
      featureFlag: FEATURE_FLAGS.SLA,
      toState: frontendURL(`accounts/${accountId}/reports/sla`),
      toStateName: 'sla_reports',
    },
    // {
    //   icon: 'document-list-clock',
    //   label: 'REPORTS_ADS',
    //   hasSubMenu: false,
    //   toState: frontendURL(`accounts/${accountId}/reports/ads`),
    //   toStateName: 'ads_reports',
    // },
    {
      icon: 'document-list-clock',
      label: 'REPORTS_ADS_ANALYTICS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/ads-analytics`),
      toStateName: 'ads_analytics_reports',
    },
    {
      icon: 'arrow-trending-lines',
      label: 'REPORTS_CUSTOM_ANALYTICS',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/reports/custom-analytics`),
      toStateName: 'custom_analytics_reports',
    },
    {
      // The Co-living module's ticket reports; shown only while that module
      // is the account's active one (Secondary.vue reads moduleRestricted).
      icon: 'ticket',
      label: 'REPORTS_CO_LIVING_TICKETS',
      hasSubMenu: false,
      moduleRestricted: 'co_living',
      toState: frontendURL(`accounts/${accountId}/co_living/reports`),
      toStateName: 'co_living_reports',
    },
  ],
});

export default reports;
